<template>
<div id="container_app">
   <div class="locationWrap support">
     <div>
       <span class="inner aniBox type_right gogo"><span>D</span>ata <br><span>A</span>nalysis <br><span>M</span>arketplace for <br><span>D</span>ata<br><span>A</span>lliance</span>
       <strong class="inner locTit aniBox type_bot gogo">
         <p class="">데이터로 가치를 담다. 혁신을 담다. 비전을 담다.</p>이용안내
       </strong>
     </div>
   </div>
   <div class="contents">
     <div class="inner">
       <div id = "move" class="subTitWrap aniBox type_left gogo">
         <h2>공지사항</h2>
       </div>

       <h3 class="subTxt">담다의 새로운 소식 및 뉴스를 전해드립니다.</h3>

       <form name="frm_search" @submit.prevent="loadData(1, true)">
       <div class="topSearchArea clearfix">
         <div class="topSearch clearfix">
           <select name="search_field" id="" class="select_ty1" v-model="searchOpt.keyType">
             <option value="01">전체</option>
             <option value="02">제목</option>
             <option value="03">내용</option>
           </select>
           <div class="inputBox">
             <input type="text" class="input_ty1" name="search_keyword" value="" v-model="searchOpt.keyWord" >
             <input type="button" class="btn_search" value="" @click="loadData(1, true) ">
           </div>
         </div>
       </div>
       </form>
       <div class="main_notice" id="main_notice">
           <ul class="main_notice_list clearfix">
             <li v-for="listItem in gridData" :key="listItem.keyid">
               <a href="javascript:" @click="goDetail(listItem.keyid)">
                 <div class="img_box aniBox type_cv delay01 gogo">
                  <template v-if="listItem.thumb">
                    <span class="bg_img" :style="{ 'background-image': 'url(' + listItem.thumb + ')' }"></span>
                  </template>
                  <template v-else>
                    <span class="bg_img"></span>
                  </template>
                 </div>
                 <div class="txt_box aniBox type_bot delay01 gogo">
                   <strong class="ellipsis" v-text="listItem.title" :class="{ 'bell' : isImportant(listItem.importantYn), 'new' : isNewM(listItem.regDate) }"></strong>
                   <span v-text="dateFmt(listItem.regDate)"></span>
                   <p class="ellipsis" v-html="listItem.cvtContents?listItem.cvtContents:'&nbsp;'"></p>
                 </div>
               </a>
             </li>
           </ul>
           <!--div class="searchNothing" v-if="gridData.length === 0">
             <img src="/static/images/contents/icon_info.png" alt="">
             <p>조회결과가 없습니다.</p>
           </div-->
           <div class="btn_area taC aniBox type_bot gogo btn_more" v-if="pageInfo.pageNo < pageInfo.nextPageNo">
             <a href="javascript:" @click="nextPage()">더보기&nbsp;&nbsp;&nbsp;+</a>
           </div>
           <infinite-loading @infinite="infiniteHandler">
             <div slot="no-results"></div>
             <div slot="no-more"></div>
           </infinite-loading>
         </div>
     </div>
   </div>
   <!--scroll-loader :loader-method="nextPage()" :loader-enable="loadMore">
   </scroll-loader-->

 </div>

</template>

<script>
import axios from 'axios'
import moment from 'moment'
// import ScrollLoader from 'vue-scroll-loader'
import InfiniteLoading from 'vue-infinite-loading'

export default {
  name: 'SupportNotice',
  components: {
    // ScrollLoader
    InfiniteLoading
  },
  data () {
    return {
      gridData: [],
      pageInfo: [],
      pageNo: 0,
      countPerPage: 8,
      searchOpt: {
        keyWord: '',
        keyType: '01'
      },
      loadMore: false
    }
  },
  methods: {
    dateFmt (dt) {
      return moment(dt).format('YYYY-MM-DD')
    },
    isImportant: function (val) {
      if (val === 'Y') return true
      else return false
    },
    isNewM: function (dt) {
      var now = moment()
      var regdt = moment(dt)
      return now.diff(regdt, 'days') < 3
    },
    nextPage () {
      var _this = this
      if (_this.pageNo < _this.pageInfo.finalPageNo) {
        _this.pageNo = _this.pageNo + 1
        _this.loadData(_this.pageNo, false)
      }
    },
    infiniteHandler ($state) {
      var _this = this
      _this.pageNo = _this.pageNo + 1
      var params = {
        pageNo: _this.pageNo,
        countPerPage: _this.countPerPage,
        keyType: _this.searchOpt.keyType,
        keyWord: _this.searchOpt.keyWord
      }
      axios.get('/web/api/board/NOT', { withCredentials: true, params: params })
        .then(response => {
          if (response.data.result) {
            _this.gridData.push(...response.data.result)
          } else {
            _this.gridData = []
          }
          _this.pageInfo = response.data.page
          if (_this.pageNo < _this.pageInfo.nextPageNo) $state.loaded()
          else $state.complete()
        })
        .catch(e => {
          console.log('error : ', e)
        })
    },
    loadData (no, re) {
      var _this = this
      _this.pageNo = no
      var params = {
        pageNo: no || 1,
        countPerPage: _this.countPerPage,
        keyType: _this.searchOpt.keyType,
        keyWord: _this.searchOpt.keyWord
      }
      axios.get('/web/api/board/NOT', { withCredentials: true, params: params })
        .then(response => {
          if (re) {
            if (response.data.result) {
              _this.gridData = response.data.result
            } else {
              _this.gridData = []
            }
          } else {
            if (response.data.result) {
              _this.gridData = _this.gridData.concat(response.data.result)
            } else {
            }
          }
          _this.pageInfo = response.data.page
          if (_this.pageNo < _this.pageInfo.nextPageNo) _this.loadMore = true
          else _this.loadMore = false
          console.log(_this.loadMore)
        })
        .catch(e => {
          console.log('error : ', e)
        })
    },
    goDetail (no) {
      this.$router.push('/support/notice/' + no)
    }
  },
  created () {
  },
  computed: {
  },
  mounted () {
    var location = document.querySelector("#move").offsetTop;
    window.scrollTo({top:location, behavior:'smooth'})
    //window.scrollTo(0, 0)
    // this.loadData(1, true)
  },
  watch: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SupportNotice.vue